import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  ViewEncapsulation,
} from '@angular/core';
import type { ClassValue } from 'clsx';
import { mergeClasses } from 'src/app/@core/utils/merge-classes';

/**
 * Helm dialog header component (spartan layer).
 * Provides a flex column container with spacing for the dialog title and description.
 */
@Component({
  selector: 'hlm-dialog-header, [hlmDialogHeader]',
  standalone: true,
  host: {
    '[class]': '_computedClass()',
  },
  template: '<ng-content />',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class HlmDialogHeaderComponent {
  readonly userClass = input<ClassValue>('', { alias: 'class' });

  protected readonly _computedClass = computed(() =>
    mergeClasses(
      'flex flex-col space-y-1.5 text-center sm:text-left',
      this.userClass(),
    ),
  );
}
